module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_styled_01-a3ac1e0720f7156429054f427a767525.jpg";